<template>
  <div class="background">
    <div class="unsubscribe" v-if="!successUnsubscribe">
      <head-title class="head-title">Email Subscriptions Management</head-title>
      <div class="unsubscribe__body">
        <div class="unsubscribe__identify-text">
          Identify from what you want to unsubscribe:
        </div>
        <checkbox-el v-model="checked" id="checkbox1">Turn off “Email” channel for current persistent alert</checkbox-el>
        <table class="unsubscribe__table">
          <tr>
            <td class="unsubscribe__td">
              <div class="unsubscribe__table-label">
                Currency
              </div>
              BitCoin (BTC)
            </td>
            <td class="unsubscribe__td">
              <div class="unsubscribe__table-label">
                Parameter
              </div>
              Market cap
            </td>
            <td class="unsubscribe__td">
              <div class="unsubscribe__table-label">
                Condition
              </div>
              Percentage Decrease
            </td>
            <td class="unsubscribe__td">
              <div class="unsubscribe__table-label">
                Value
              </div>
              20%
            </td>
          </tr>
        </table>
        <div class="checkbox-wrap checkbox-wrap_email">
          <checkbox-el class="checkbox" id="checkbox2">Turn off “Email” channels for all alerts;</checkbox-el>
          <div class="checkbox__description">You will stop receiving notifications on your email about any of your triggered alerts</div>
        </div>
        <div class="checkbox-wrap checkbox-wrap_cryptomarket">
          <checkbox-el class="checkbox" id="checkbox3">Unsubscribe from “Crypto Market Analytics”;</checkbox-el>
          <div class="checkbox__description">We will no longer send you our periodic overview of the сryptocurrency market, including information on currencies added to your favorites and news digest</div>
        </div>
        <div class="checkbox-wrap checkbox-wrap_marketing">
          <checkbox-el class="checkbox" id="checkbox4">Unsubscribe from marketing mailing;</checkbox-el>
          <div class="checkbox__description">We will no longer send you any information about our promotions and offers</div>
        </div>
        <button-el red class="btn">Unsubscribe</button-el>
      </div>
    </div>

    <div v-else class="success-popup">
      <head-title class="head-title">Succesfully unsubscribed!</head-title>
      <div class="success-popup__body">
        <span class="success-popup__text" v-if="successText1">
          You are successfully unsubscribed from “Crypto Market Analytics”. You can resubscribe again at <router-link to="/settings">settings page</router-link>
        </span>
        <span class="success-popup__text" v-else-if="successText2">
          You are successfully turned off “Email” channel for all alerts. You can manage notification channels at<br/> <router-link to="/alert-management">alert management page</router-link>
        </span>
        <span class="success-popup__text" v-else-if="successText3">
          You are successfully unsubscribed from “Marketing emails”. You can resubscribe again at <router-link to="/settings">settings page</router-link>
        </span>
        <span class="success-popup__text" v-else-if="successText4">
          You are successfully turned off “Email” channel for current alert. You can manage notification<br/> channels at <router-link to="/alert-management">alert management page</router-link>
        </span>
        <span class="success-popup__text" v-else-if="successText5">
          You are successfully turned off “Email” channel<br/> for all alerts, unsubscribed from marketing mailing, unsubscribed from “Crypto Market Analytics”.<br/> You can resubscribe for marketing mailing and<br/> “Crypto Market Analytics” at <router-link to="/settings">settings page</router-link>, manage alerts channels at <router-link to="/alert-management">alert management page</router-link>.
        </span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data: () => ({
    checked: true,
    successUnsubscribe: false,
    successText1: true,
    successText2: false,
    successText3: false,
    successText4: false,
    successText5: false,
  }),
};
</script>

<style lang="scss" scoped>
.background {
  @include background;
}
.unsubscribe {
  @include container;
  max-width: 646px;
  background: $white-color2;
  border-radius: 5px;
  &__body {
    padding: 25px 32px 30px;
  }
  &__table {
    padding: 17px 35px 23px;
  }
  &__td:not(:last-child) {
    padding-right: 54px;
  }
  &__table-label {
    @include font(12px, $grey-color2);
    padding-bottom: 11px;
  }
  &__identify-text {
    @include font(13px);
    line-height: 23px;
    padding-bottom: 20px;
    letter-spacing: 0.1px;
  }
}
.head-title {
  padding: 31px 28px;
  border-bottom: 1px solid $white-color5;
}
.checkbox {
  margin-top: 15px;
  &__description {
    @include font(13px, $grey-color9, 500);
    line-height: 21px;
    padding-left: 38px;
    margin-top: 8px;
    padding-right: 40px;
  }
}
.checkbox-wrap {
  &_cryptomarket {
    margin-top: 32px;
    padding-right: 30px;
  }
  &_marketing {
    margin-top: 32px;
    padding-right: 40px;
  }
}
.btn {
  margin-top: 44px;
}
.success-popup {
  width: 100%;
  margin: auto;
  max-width: 419px;
  background: $white-color2;
  border-radius: 5px;
  .head-title {
    padding: 31px 28px;
    border-bottom: 1px solid $white-color5;
  }
  &__body {
    padding: 25px 20px 25px 32px;
  }
  &__text {
    @include font(13px, $black-color1);
    line-height: 23px;
    a {
      color: $red-color3;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Unsubscribe.vue